import axios from 'axios';
import { API_URL } from '../constants';
import APIKit from '../APIKit';
  
  export const getConnectList = (payload) => {
    return new Promise(async (resolve, reject) => {
      try {
        payload.append("auth_token", window.localStorage.getItem("auth_token"));
      } catch (e) {
      }
      
      APIKit.post("/fws_connected_user", payload)
        .then(async (response) => {
          try {
            resolve(response.data);
          } catch (e) {
            reject(e);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  export const connectRequest = (payload) => {
    return new Promise(async (resolve, reject) => {
      try {
        payload.append("auth_token", window.localStorage.getItem("auth_token"));
      } catch (e) {
      }
      
      APIKit.post("/connect_fws", payload)
        .then(async (response) => {
          try {
            resolve(response.data);
          } catch (e) {
            reject(e);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }